export default "__VITE_ASSET__f352ff99__"